import React, { useState } from 'react';

import { FeedbackContext } from './feedbackContext';

type FeedbackProviderProps = {
    children: React.ReactNode;
};

export function FeedbackProvider(props: FeedbackProviderProps) {
    const { children } = props;
    const [alerts, setAlerts] = useState<any>([]);

    const addAlert = (alert: any) => {
        setAlerts([...alerts, alert]);
    };

    const deleteAlert = (index: any) => {
        let alertsClone = [...alerts];
        alertsClone.splice(index, 1);

        setAlerts(alertsClone);
    };

    const removeAllAlert = () => {
        setAlerts([]);
    };

    const [positionToBottom, setPositionToBottom] = useState<boolean>(false);

    return (
        <FeedbackContext.Provider
            value={{
                alerts,
                addAlert,
                deleteAlert,
                removeAllAlert,
                positionToBottom,
                setPositionToBottom,
            }}
        >
            {children}
        </FeedbackContext.Provider>
    );
}
